<template>
  <v-btn color="bad" outlined v-bind="$attrs" v-on="$listeners"> <slot></slot></v-btn>
</template>

<script>
export default {
  name: "core-btn-negative",
  props: {},
  components: {},
}
</script>
